var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteTick2 = function SvgWhiteTick2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.394,
    height: 14.425,
    viewBox: "0 0 18.394 14.425",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18442",
    "data-name": "Group 18442",
    transform: "translate(-138.898 -241.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_610548_cc",
    transform: "translate(139.398 242.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M45.688,34.855a.729.729,0,0,0-.486.254L35.212,46.545,30.34,42.111a.736.736,0,0,0-1.023.028.694.694,0,0,0,.028,1l5.425,4.941a.736.736,0,0,0,1.051-.055l10.488-12a.693.693,0,0,0,.1-.793A.728.728,0,0,0,45.688,34.855Z",
    transform: "translate(-29.12 -34.85)",
    fill: "#f9f9f9",
    stroke: "#f9f9f9",
    strokeWidth: 1
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteTick2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteTick2.18f96e4e.svg";
export { ForwardRef as ReactComponent };